import { render, staticRenderFns } from "./ContactLinker.vue?vue&type=template&id=53ab1ebd&"
import script from "./ContactLinker.vue?vue&type=script&lang=js&"
export * from "./ContactLinker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports